import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { DARK } from "./seedance/constants";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{
        minHeight: "100vh", background: DARK.bg, color: DARK.textDim,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'IBM Plex Sans','Helvetica Neue',sans-serif", fontSize: 13,
      }}>Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
